import { render } from "./MyAccountTickets.vue?vue&type=template&id=1cbe2e79&scoped=true&lang=pug"
import script from "./MyAccountTickets.vue?vue&type=script&lang=ts"
export * from "./MyAccountTickets.vue?vue&type=script&lang=ts"

import "./MyAccountTickets.vue?vue&type=style&index=0&id=1cbe2e79&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1cbe2e79"

export default script